import { Waves, QrCode, KeyRound, HeartPulse, Clock, Webhook } from "lucide-react";

const IDEAS = [
  {
    icon: Waves,
    title: "WebRTC Live Audio",
    desc: "Add a full two-way audio pipeline so tenants can talk to visitors directly in the browser when they accept a ring — no softphone app needed.",
    tag: "NEXT UP",
  },
  {
    icon: QrCode,
    title: "Softphone QR Provisioning",
    desc: "Generate a QR code per extension so tenants can one-tap configure Linphone / Zoiper on their phones with the SIP credentials already stored here.",
    tag: "QUICK WIN",
  },
  {
    icon: KeyRound,
    title: "Door Latch Integration",
    desc: "Wire the Unlock button to the physical door relay (GPIO / HTTP relay on the intercom) so 'door_unlocked' events actually open the entrance.",
    tag: "HARDWARE",
  },
  {
    icon: HeartPulse,
    title: "Server Heartbeat Monitoring",
    desc: "Ping each SIP server on a schedule, show real health in the console, and alert you when an intercom or server drops offline.",
    tag: "RELIABILITY",
  },
  {
    icon: Clock,
    title: "Time-Based Call Forwarding",
    desc: "Redirect an unanswered ring after 15 seconds to a secondary extension or a mobile softphone — useful when tenants miss the browser ring.",
    tag: "ROUTING",
  },
  {
    icon: Webhook,
    title: "Offline Alert Webhooks",
    desc: "Send an email or webhook to the admin when a tenant's intercom or a site goes dark, so you know before residents complain.",
    tag: "ALERTING",
  },
];

export function IdeasTab() {
  return (
    <div data-testid="ideas-tab">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-slate-100">Improvement Roadmap</h3>
        <p className="text-sm text-slate-400 mt-1">Suggested next steps for Scharpz Live! based on your setup.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {IDEAS.map((idea, i) => (
          <div key={i} className="ops-card p-5 hover:border-[#2A364F] transition-colors" data-testid={`idea-card-${i}`}>
            <div className="flex items-center justify-between mb-3">
              <div className="w-9 h-9 rounded-lg bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center">
                <idea.icon className="w-4.5 h-4.5 text-emerald-400" />
              </div>
              <span className="ops-caption text-emerald-400/70">{idea.tag}</span>
            </div>
            <div className="font-semibold text-slate-100 mb-1.5">{idea.title}</div>
            <p className="text-sm text-slate-400 leading-relaxed">{idea.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
